import PropTypes from 'prop-types';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Grid, TextField } from '@mui/material';
import { useAddCodesToLotMutation } from '../../features/api/rest/apiLotsSlice';
import { setAlertMessage } from '../../features/layoutSlice';

function AddCodeDialog({ ean, opk, lpk, isOpen, setIsOpen }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [addCodesToLot] = useAddCodesToLotMutation();
  const [quantity, setQuantity] = useState(1);

  const createCodes = async () => {
    try {
      await addCodesToLot({ ean, opk, lpk, amount: quantity });
      dispatch(setAlertMessage({ text: t('organizations.product.lots.addCodes.successMessage'), type: 'success' }));
    } catch (error) {
      dispatch(setAlertMessage({ text: t('organizations.product.lots.addCodes.errorMessage'), type: 'error' }));
    } finally {
      setIsOpen(false);
    }
  };

  const handleCounter = (value) => {
    if (value === '' || (Number(value) > 0 && !isNaN(value))) {
      setQuantity(value);
    }
  };

  return (
    <Dialog open={isOpen} onClose={() => setIsOpen(false)} fullWidth>
      <DialogTitle sx={{ textAlign: 'center' }}>{t('organizations.product.lots.addCodes.dialog.title')}</DialogTitle>
      <DialogContent>
        <Grid container display="flex" sx={{ placeContent: 'center' }} justifyContent="left" gap={1} p={0} pt={2}>
          <Grid item xs={5}>
            <TextField
              size="small"
              id="Quantity"
              type="number"
              InputLabelProps={{
                shrink: true,
              }}
              name="Quantità"
              label={t('organizations.product.lots.addCodes.dialog.label')}
              variant="outlined"
              fullWidth
              value={quantity}
              placeholder={t('organizations.product.lots.addCodes.dialog.label')}
              onChange={(e) => handleCounter(e.target.value)}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions sx={{ pt: 0, pb: 3, px: 3 }}>
        <Grid container display="flex" justifyContent="space-between" gap={1}>
          <Grid item>
            <Button type="submit" variant="outlined" color="secondary" onClick={() => setIsOpen(false)}>
              {t('organizations.form.close')}
            </Button>
          </Grid>
          <Grid item>
            <Button type="submit" variant="contained" color="primary" onClick={createCodes}>
              {t('common.actions.add')}
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
}

export default AddCodeDialog;

AddCodeDialog.propTypes = {
  ean: PropTypes.string.isRequired,
  opk: PropTypes.string.isRequired,
  lpk: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
};
